export const EventShared = {
    HOST_REDIRECT_DETAIL_MASTER: "HOST_REDIRECT_DETAIL_MASTER",
    HOST_RELOAD_USER_INFO: "HOST_RELOAD_USER_INFO",
    CHANGE_THEME: "CHANGE_THEME",
    CHANGE_LANGUAGE: "CHANGE_LANGUAGE",
};


export const ScopeShared = {
    ALL: "ALL",
    MF: "MF",
}
